"use client";

import * as React from "react";
import { Droplets, Home, AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServices() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: Droplets,
    title: "Commercial Water Pump Systems",
    description: "Industrial-grade water pump installations including booster pumps, line-shaft turbines, and high-capacity systems for commercial buildings, fire suppression, and large-scale operations.",
    iconColor: "text-primary",
    iconBg: "bg-primary/10"
  }, {
    icon: Home,
    title: "Residential Water Pump Services",
    description: "Expert submersible pump installation, well pump maintenance, irrigation pump systems, and residential booster pumps to ensure consistent water pressure throughout your home.",
    iconColor: "text-secondary",
    iconBg: "bg-secondary/10"
  }, {
    icon: AlertCircle,
    title: "Emergency Pump Services",
    description: "24/7 emergency water pump repairs, sewage lift station maintenance, pump motor rewinds, and urgent troubleshooting for all pump types to minimize downtime and water flow disruptions.",
    iconColor: "text-accent",
    iconBg: "bg-accent/10"
  }];
  return <section className="py-16 px-6 bg-background">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground">Water Pump Services</h2>
          <p className="mt-4 text-lg text-muted">Comprehensive water pump solutions for every application</p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          <div ref={card1Ref} data-index={0} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${card1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="h-full bg-light-background/60 backdrop-blur-md border border-border/50 rounded-xl shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <CardContent className="pt-6 flex flex-col items-center text-center">
                <div className={`mb-6 flex h-16 w-16 items-center justify-center rounded-full ${services[0].iconBg}`}>
                  <Droplets className={`h-8 w-8 ${services[0].iconColor}`} />
                </div>
                <h3 className="mb-3 text-xl font-display font-semibold text-foreground">{services[0].title}</h3>
                <p className="text-base leading-relaxed text-muted-foreground">
                  {services[0].description}
                </p>
              </CardContent>
            </Card>
          </div>

          <div ref={card2Ref} data-index={1} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${card2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: card2Visible ? "100ms" : "0ms"
        }}>
            <Card className="h-full bg-light-background/60 backdrop-blur-md border border-border/50 rounded-xl shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <CardContent className="pt-6 flex flex-col items-center text-center">
                <div className={`mb-6 flex h-16 w-16 items-center justify-center rounded-full ${services[1].iconBg}`}>
                  <Home className={`h-8 w-8 ${services[1].iconColor}`} />
                </div>
                <h3 className="mb-3 text-xl font-display font-semibold text-foreground">{services[1].title}</h3>
                <p className="text-base leading-relaxed text-muted-foreground">
                  {services[1].description}
                </p>
              </CardContent>
            </Card>
          </div>

          <div ref={card3Ref} data-index={2} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${card3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: card3Visible ? "200ms" : "0ms"
        }}>
            <Card className="h-full bg-light-background/60 backdrop-blur-md border border-border/50 rounded-xl shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <CardContent className="pt-6 flex flex-col items-center text-center">
                <div className={`mb-6 flex h-16 w-16 items-center justify-center rounded-full ${services[2].iconBg}`}>
                  <AlertCircle className={`h-8 w-8 ${services[2].iconColor}`} />
                </div>
                <h3 className="mb-3 text-xl font-display font-semibold text-foreground">{services[2].title}</h3>
                <p className="text-base leading-relaxed text-muted-foreground">
                  {services[2].description}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}